module.exports = __webpack_public_path__ + "img/denonaB1.4a36ef41.jpg";